<div mat-dialog-title>
	<div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayoutGap="15px grid">
		<div>Parcel Barcode: {{parcelDetail?.barcode}}</div>
	</div>
</div>
<mat-dialog-content>
	<div fxLayout="row" fxLayoutGap="15px">
		<div fxFlex fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
			<div *ngIf="user?.token" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="5px">
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Delivery Location</div>
					<div class="address-wrapper" fxLayout="column">
						<div>{{parcelDetail?.deliveryAddress?.name}}</div>
						<div>{{parcelDetail?.deliveryAddress?.address1}} {{parcelDetail?.deliveryAddress?.address2}}</div>
						<div>{{parcelDetail?.deliveryAddress?.city}}, {{parcelDetail?.deliveryAddress?.state}} {{parcelDetail?.deliveryAddress?.zip}}</div>
						<div>{{parcelDetail?.origin?.originComments}}</div>
					</div>
				</div>
				<div *ngIf="parcelDetail?.status" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Status</div>
					<div [ngClass]="{
						'delivered' : parcelDetail?.status === 'Delivered',
						'notScanned' : parcelDetail?.status === 'Not Scanned',
						'inTransit' : parcelDetail?.status !== 'Not Scanned' && parcelDetail?.status !== 'Delivered'
					 }">{{parcelDetail?.status?.toUpperCase()}}</div>
				</div>
				<div *ngIf="parcelDetail?.id" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Parcel ID</div>
					<div>{{parcelDetail?.id}}</div>
				</div>
				<div *ngIf="parcelDetail?.type" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Parcel Type</div>
					<div>{{parcelDetail?.type?.description}}</div>
				</div>
				<div *ngIf="parcelDetail?.refrigeration" class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Refrigeration Type</div>
					<div>{{parcelDetail?.refrigeration.charAt(0).toUpperCase() + parcelDetail?.refrigeration.slice(1).replace('_',' ').toLowerCase()}}</div>
				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Pieces / Weight</div>
					<div>{{parcelDetail?.pieces}} / {{parcelDetail?.weight}}</div>
				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Initial Scan Date</div>
					<div *ngIf="parcelDetail?.initialScanTime">{{parcelDetail?.initialScanTime.formattedDate}} {{parcelDetail?.initialScanTime.formattedTime}} {{parcelDetail?.initialScanTime.timeZone}}</div>
					<div *ngIf="!parcelDetail?.initialScanTime">Not Scanned</div>				</div>
				<div class="bottom-border-row" fxLayout="row wrap" fxLayoutAlign="space-between">
					<div class="label">Last Scan Date</div>
					<div *ngIf="parcelDetail?.lastScanTime">{{parcelDetail?.lastScanTime.formattedDate}} {{parcelDetail?.lastScanTime.formattedTime}} {{parcelDetail?.lastScanTime.timeZone}}</div>
					<div *ngIf="!parcelDetail?.lastScanTime">Not Scanned</div>
				</div>
			</div>
			<div *ngIf="user?.token && parcelDetail?.trackingDetails?.length !== 0">
				<h3>Parcel Scan History:</h3>
				<div class="mat-table-wrapper">
					<mat-table [dataSource]="parcelDetail?.trackingDetails" matSort>
						<ng-container matColumnDef="dateTime">
							<mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="true">
								Date / Time
							</mat-header-cell>
							<mat-cell *matCellDef="let element"
									  [attr.data-label]="'Date / Time'">
								{{element?.scanTime?.formattedDate}} {{element?.scanTime?.formattedTime}} {{element?.scanTime?.timeZone}}
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="status">
							<mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="true">
								Action
							</mat-header-cell>
							<mat-cell *matCellDef="let element" [attr.data-label]="'Action'">
								{{ element?.scanStatus + ' '}}
								<div *ngIf="element?.exceptionId" class="icon-wrap">
									<mat-icon [matTooltip]="element?.exceptionId + ' - ' + element?.exceptionDescription"
											  class="icon-size-26 warning-text"
											  matTooltipPosition="right">warning
									</mat-icon>
								</div>
								<div *ngIf="element.assignmentItems?.length > 0" class="icon-wrap">
									<mat-icon color="primary" class="icon-size-26">inventory_2</mat-icon>
								</div>
							</mat-cell>
						</ng-container>
						<ng-container matColumnDef="location">
							<mat-header-cell *matHeaderCellDef mat-sort-header [disabled]="true">
								Scan Location
							</mat-header-cell>
							<mat-cell *matCellDef="let element"
									  [attr.data-label]="'Scan Location'">
								{{element?.address?.name}}<br>
								{{element?.address?.address1}} {{element?.address?.address2}}<br>
								{{element?.address?.city}}, {{element?.address?.state}} {{element?.address?.zip}}
							</mat-cell>
						</ng-container>
						<mat-header-row *matHeaderRowDef="['dateTime', 'status', 'location']"></mat-header-row>
						<mat-row *matRowDef="let row; columns: ['dateTime', 'status', 'location'];" [cdkDetailRowTpl]="tpl" [cdkDetailRow]="row" matRipple></mat-row>
					</mat-table>
					<ng-template #tpl let-element>
						<div [@detailExpand] class="mat-row detail-row overflow-hidden">
							<app-parcel-items [assignments]="constructAssignments(element)"></app-parcel-items>
						</div>
					</ng-template>
				</div>
			</div>
			<div>
				<app-attachment-list [access]="2" [podAttachments]="podAttachments"
									 [regularAttachments]="regularAttachments"
									 [workOrder]="{attachments: parcelDetail?.attachmentDetails, id: parcelDetail?.id, type: parcelDetail?.type}"></app-attachment-list>
			</div>
			<div *ngIf="user?.token && (parcelDetail?.pod || parcelDetail?.signature)" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="15px">
				<h3>{{'trackOrderDetailsView.podHeader' | translate}}:</h3>
				<div *ngIf="parcelDetail?.pod" class="bottom-border-row" fxLayout="row wrap"
					 fxLayoutAlign="space-between">
					<div class="label">Proof of Delivery</div>
					<div>{{parcelDetail?.pod}}</div>
				</div>
				<img *ngIf="parcelDetail?.signature" [src]="parcelDetail?.formattedSignature" class="pod-image"/>
			</div>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end">
	<button (click)="email()" color="accent" mat-dialog-close mat-raised-button type="button">
		Email
	</button>
	<button (click)="print()" color="accent" mat-dialog-close mat-raised-button type="button">
		Print
	</button>
	<button color="accent" mat-dialog-close mat-raised-button type="button">
		Close
	</button>
</mat-dialog-actions>
